import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const spacelift = defineConnector({
  identifier: "spacelift",
  name: "Spacelift",
  tagLine: "Infrastructure as code management platform",
  logo,
  protocol: "http",
  tags: ["engineering"],
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `${app.config.accountUrl}/graphql`,
        jsonBody: {
          query: `mutation { apiKeyUser(id: "${app.secret.apiKeyId}", secret: "${app.secret.apiKeySecret}") { jwt } }`,
        },
      },
      extract: { from: "jsonPath", paths: ["data.apiKeyUser.jwt"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Enter your Spacelift account subdomain",
      items: [
        {
          kind: "markdown",
          content:
            "Provide your Spacelift account URL (e.g. `https://your-account.app.spacelift.io`).",
        },
        {
          kind: "url",
          label: "Account URL",
          required: true,
          target: { kind: "configuration", field: "accountUrl" },
          placeholder: "https://your-account.app.spacelift.io",
        },
      ],
    },
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Spacelift, go to **Settings → API Keys** and create a new API key. Copy both the key ID and the secret.",
        },
        {
          kind: "input",
          label: "API key ID",
          required: true,
          target: { kind: "secrets", field: "apiKeyId" },
        },
        {
          kind: "input",
          label: "API key secret",
          required: true,
          target: { kind: "secrets", field: "apiKeySecret" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ accountUrl }) => domainToRegex(accountUrl),
  connectionTest: {
    protocol: "http",
    request: ({ accountUrl }) => `${accountUrl}/graphql`,
  },
});
